import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Client } from "@twilio/conversations";
import decodeJwt from "helpers/jwt-token-access/jwtdecode";
import { FaVideo, FaClock, FaSearch, FaUser, FaPaperclip, FaSmile } from "react-icons/fa";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading, setLoading } from "slices/contract/reducer";
import apiUrl from "slices/apiEndpoint";
import { getDecodeId, getUserName } from "slices/userProfile/thunk";
import api from "Common/api";

interface PropsChat {
  project: any;
}

const ChatComponent = ({ project }: PropsChat) => {
  const [token, setToken] = useState("");
  const [chatClient, setChatClient] = useState<Client | null>(null);
  const [messages, setMessages] = useState<any[]>([]);
  const [messageInput, setMessageInput] = useState("");
  const [conversation, setConversation] = useState<any>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const userType = decodeJwt()?.userType;
  const homeOwnerId = project.p_home_owner_id;
  const homeownerData = project.home_owner
  const contractorId = project.p_contractor_id;
  const projectId = project.p_id;
  const identity = `user_${userType === "homeowner" ? homeOwnerId : contractorId}`;
const loading = useSelector(selectLoading)
const dispatch = useDispatch()
  useEffect(() => {
    if (!homeOwnerId) return;

    const fetchToken = async () => {
      try {
        dispatch(setLoading(true))
        const res = await fetch(`/chat/generate-token`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ identity }),
        });
        const data = await res.json();
        console.log("✅ Token received:", data.token);

        setToken(data.token);
        const client = new Client(data.token);
        setChatClient(client);

        client.on("stateChanged", async (state) => {
          console.log("🔄 Client state changed:", state);
          if (state === "initialized") {
            getOrCreateConversation(client);
          }else{
        dispatch(setLoading(false))

          }
        });
      } catch (error) {
        dispatch(setLoading(false))
        console.error("❌ Error fetching token:", error);
      }
    };

    fetchToken();
  }, [homeOwnerId]);
  const registerUserIfNeeded = async (identity: string) => {
    try {
      // 🔹 Check if the user exists via your Node.js API
      const res = await api.get(`/chat/check-user/${identity}`);
  
      if (res.data.registered) {
        console.log(`🟢 User exists in Twilio: ${identity}`);
      } else {
        console.log(`🟡 User not found. Registering: ${identity}`);
  
        // 🔹 Register user via your Node.js API
        await api.post(`/chat/register-user`, { identity });
  
        console.log(`✅ User registered: ${identity}`);
      }
    } catch (error: any) {
      console.error("❌ Error checking/registering user:", error);
    }
  };
  const chatID = `Contractor-${contractorId}_Project-${projectId}_HomeOwner-${homeOwnerId}`;
const friendlyName =  `${contractorId}-${project?.contractor?.user_first_name}_${homeOwnerId}-${project?.home_owner.user_first_name}_${"contract-"+ project.p_name}`;
  const getOrCreateConversation = async (client: Client) => {

    try {
      let convo = await client.getConversationByUniqueName(chatID).catch(async () => {
        console.log("❌ No existing conversation found, creating a new one...");
        const newConvo = await client.createConversation({ uniqueName: chatID, friendlyName: friendlyName  });
        console.log("🆕 New conversation created:", newConvo.sid);
        await newConvo.join();
        return newConvo;
      });

      console.log("🔄 Fetching participants...");
      const participants = await convo.getParticipants();
      console.log("👥 Current participants:", participants.map((p: any) => p.identity));

      const addUserToConversation = async (identity: string) => {
        if (!participants.some((p: any) => p.identity === identity)) {
          console.log(`🟡 Checking & registering user if needed: ${identity}`);
          await registerUserIfNeeded(identity);
  
          console.log(`🟡 Adding user: ${identity}`);
          await convo.add(identity);
        }
      };

      await addUserToConversation(`user_${contractorId}`);
      await addUserToConversation(`user_${homeOwnerId}`);

      console.log("✅ Participants added successfully!");
      setConversation(convo);
      loadMessages(convo);

      convo.on("messageAdded", (message: any) => {
        console.log("📩 New message received:", message.body);
       
        setMessages((prev) => [...prev, message]);
      });
    } catch (error) {
      console.error("❌ Error getting/creating conversation:", error);
    } finally{
      dispatch(setLoading(false))

    }
  };

  const loadMessages = async (convo: any) => {
    console.log("📩 Loading messages...");
    const messages = await convo.getMessages();
    console.log("✅ Messages loaded:", messages.items.length);
    setMessages(messages.items);
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
const messagesEndRef = useRef<HTMLDivElement | null>(null);

useEffect(() => {
      scrollToBottom();

}, [messages]);  

  const sendMessage =()=>{
    sendTwillioMSG(conversation, messageInput, selectedFile, setSelectedFile, setMessageInput);
  }

  if (!homeOwnerId || !homeownerData) return null;
  const identityName = String( project.contractor.user_id) ===identity.replace("user_","")?project.contractor.user_first_name:project.home_owner.user_first_name
const secondUserName = String( project.contractor.user_id) !==identity.replace("user_","")?project.contractor.user_first_name:project.home_owner.user_first_name
  const chatName =project.p_name

  return (
<div style={{
  width:'100%',
}} className="tflex ">
<ChatUI messagesEndRef={messagesEndRef} chatName={chatName} secondUserName={secondUserName} identityName={identityName} loading={loading} selectedFile={selectedFile} setSelectedFile={setSelectedFile} messageInput={messageInput} setMessageInput={setMessageInput}  messages={messages} identity={identity} sendMessage={sendMessage} />
  
  
</div>
  );
};

export default ChatComponent;





interface Message {
  sender: string;
  time: string;
  text: string;
  self: boolean;
}
interface chatuiProps {
  messages:any
}
export const GetImg = ({ msg }: { msg: any }) => {
  const [mediaUrl, setMediaUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchMediaUrl = async () => {
      if (msg.media) {
        const url = await msg.media.getContentTemporaryUrl();
        setMediaUrl(url);
      }
    };

    fetchMediaUrl();
  }, [msg.media]);
  if (!mediaUrl) return null;

  return <img style={{
    height:100,
    width:100,
    borderRadius:10
  }} src={mediaUrl} alt="Media" />;
};

export const ChatUI = ({messages,messagesEndRef,secondUserName,identityName,chatName,loading,selectedFile,setSelectedFile,sendMessage,identity,messageInput,setMessageInput}: { chatName:any,messagesEndRef:any,identityName:any,secondUserName:any, messages: any;sendMessage:any,loading:any,identity:any,selectedFile:any ,messageInput:any,setSelectedFile:any,setMessageInput:any})=> {

return (
    
    <div style={{
    }} className="flex-1  mt-4 mb-5 ">
    <div className="flex flex-col flex-1  border rounded-md">
      <div style={{
        borderBottom:"1px solid #d1d5db"
      }} className="flex  items-center p-2  ">
       <div className="h-[35px] flex justify-center items-center rounded-full  w-[35px]  bg-gray-300">
<div className="text-[12px] font-semibold text-gray-500">
{secondUserName .split(" ")
    .filter((word:any) => word) // Remove empty strings from multiple spaces
    .map((word:any) => word[0].toUpperCase())
    .join("")}

</div>
       </div>
       <div className="ml-3 ">
       <div className=" flex items-center text-[14px] font-semibold">{secondUserName}</div>
        <div className=" flex items-center text-[12px] ">{chatName}</div>
     
       </div>
   
      </div>
      <div         style={{
      height:300

              }} className=" flex flex-col ml-3 mt-2  overflow-y-auto">
        {messages.map((msg:any, index:any) => {
          const createdTime = new Date(msg.dateCreated.getTime());
       const user = msg.author === identity ? identityName : secondUserName
          return (
            <div
              key={index}
            >
              <div className="flex hover:bg-gray-200 w-full p-2 rounded-sm">
              <div className="h-[35px] flex justify-center items-center rounded-full  w-[35px]  bg-gray-300">
<div className="text-[12px] font-semibold text-gray-500">
{user .split(" ")
    .filter((word:any) => word) // Remove empty strings from multiple spaces
    .map((word:any) => word[0].toUpperCase())
    .join("")}

</div>
       </div>
       <div className="flex flex-col justify-start">
       <div className="flex ">
     
     <div className="ml-2 text-gray-800">
     {user} {" "}

     </div>
     <span className="text-xs ml-3">
                {createdTime.toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                })}
              </span>
             </div>
            
            <div className=" w-full  ml-2">
              <GetImg msg={msg} />
              {msg.body?.split("\n").map((line:any, i:any) => (
                <p
                  key={i}
                  className={''}
                >
                  {line}
                </p>
              ))}
            </div>
       </div>

       
              </div>
        
            </div>
          );
        })}
<div ref={messagesEndRef} />

      </div>
      <div className="p-4 border-t border-gray-300 flex items-center">
        <div className="w-full p-2 flex items-center border border-gray-300 rounded-lg tflex">
          <div className="pr-2 pl-2 relative">
            <input
              type="file"
              className="hidden"
              onChange={(e) => setSelectedFile(e.target.files?.[0] || null)}
              id="fileInput"
            />
            <i
              className="bi bi-upload text-lg cursor-pointer"
              onClick={() => document.getElementById("fileInput")?.click()}
            ></i>
            {selectedFile && (
              <div className="absolute top-[-60px] left-0 flex items-center gap-2">
                <img
                  src={URL.createObjectURL(selectedFile)}
                  alt="Preview"
                  className="w-12 h-12 object-cover rounded-md"
                />
                <button
                  className="bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center cursor-pointer"
                  onClick={() => setSelectedFile(null)}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
          <input
            type="text"
            value={messageInput}
            onChange={(e) => setMessageInput(e.target.value)}
            placeholder="Send a message..."
            className="flex-1 bg-transparent border-0 outline-none"
          />
          {loading?<div>

            Loading...
          </div>:<div
            onClick={sendMessage}
            className="pr-2 pl-2 cursor-pointer"
          >
            <i className="bi bi-send text-lg"></i>
          </div>}
          
        </div>
      </div>
    </div>
  </div>
  );
}
export async function sendTwillioMSG(conversation: any, messageInput: string, selectedFile: File | null, setSelectedFile: React.Dispatch<React.SetStateAction<File | null>>, setMessageInput: React.Dispatch<React.SetStateAction<string>>) {
  console.log('sending chat',messageInput)

  if (!conversation || (!messageInput.trim() && !selectedFile)) return;
  console.log('sending chat2')

  try {
    if (selectedFile) {
      console.log("📂 Uploading file:", selectedFile.name);
      const formData = new FormData();
      formData.append("file", selectedFile);
      await conversation.sendMessage(formData);
      setSelectedFile(null);
    } else {
      await conversation.sendMessage(messageInput);
    }
    setMessageInput("");
  } catch (error) {
    console.error("❌ Error sending message:", error);
  }
}

